import KeenSlider from 'keen-slider'
import 'keen-slider/keen-slider.min.css'

document.addEventListener('DOMContentLoaded', () => {
    const carousels = document.querySelectorAll('.wp-block-hoyry-highlight-carousel .carousel-container');
    
    carousels.forEach(container => {
        const dotsContainer = container.parentElement.querySelector('.carousel-dots');

        const slider = new KeenSlider(container, {
            loop: false,
            renderMode: "performance",
            slides: { 
                perView: 1,
                spacing: 35,
            },
            breakpoints: {
				"(max-width: 1600px)": {
					slides: {
						spacing: 30,
					}
				},
				"(max-width: 1300px)": {
					slides: {
						spacing: 25,
					}
				},
				"(max-width: 1000px)": {
					slides: {
						spacing: 20,
					}
				},
				"(max-width: 800px)": {
					slides: {
						spacing: 16,
					}
				},
				"(max-width: 600px)": {
					slides: {
						spacing: 12,
					}
				},
			},
            created: (s) => {
                container.classList.add('initialized');
                
                if (s.track.details.slides.length > 1) {
                    s.track.details.slides.forEach((_, idx) => {
                        const dot = document.createElement('button');
                        dot.classList.add('dot');
                        if (idx === 0) dot.classList.add('active');
                        
                        dot.addEventListener('click', () => {
                            slider.moveToIdx(idx);
                        });
                        
                        dotsContainer.appendChild(dot);
                    });
                }
            },
            slideChanged: (s) => {
                const prevButton = container.parentElement.querySelector('.carousel-navigation-button.left');
                const nextButton = container.parentElement.querySelector('.carousel-navigation-button.right');
                
                if (prevButton) {
                    prevButton.classList.toggle('disabled', s.track.details.abs === 0);
                }
                if (nextButton) {
                    nextButton.classList.toggle('disabled', s.track.details.abs === s.track.details.maxIdx);
                }

                updateDots(s.track.details.abs);
            }
        });
        
        const prevButton = container.parentElement.querySelector('.carousel-navigation-button.left');
        const nextButton = container.parentElement.querySelector('.carousel-navigation-button.right');
        
        if (prevButton) {
            prevButton.classList.add('disabled');
            prevButton.addEventListener('click', () => slider.prev());
        }
        if (nextButton) {
            nextButton.classList.toggle('disabled', slider.track.details.maxIdx === 0);
            nextButton.addEventListener('click', () => slider.next());
        }
        
        const observer = new ResizeObserver(() => {
            slider.update();
        });
        
        observer.observe(container);

        function updateDots(currentSlide) {
            const dots = dotsContainer.querySelectorAll('.dot');
            dots.forEach((dot, idx) => {
                dot.classList.toggle('active', idx === currentSlide);
            });
        }
    });
});